import script from "./BatchHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BatchHeader.vue?vue&type=style&index=0&id=0f20a2fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f20a2fa"]])

export default __exports__